module.exports = __webpack_public_path__ + "img/frame-1.5bc72596.svg";